module.exports = __webpack_public_path__ + "static/media/chatLoader.062cd8a6.gif";